import Phaser from 'phaser';

export class Player extends Phaser.GameObjects.Sprite {
  constructor(scene: Phaser.Scene, x: number, y: number) {
    super(scene, x, y, 'hero-run-1');
    scene.add.existing(this);
    this.setOrigin(0.5, 1).setDepth(8);
    this.setDisplaySize(48, 48);
    // Arcade dimensions are expressed in the native 16px source frame and
    // then scaled with the sprite (48px on screen). This produces 30×36px.
  }

  run(_speed = 0): void { this.play('hero-run', true); }
  jump(_speed = 0): void {
    this.anims.stop();
    this.setTexture('hero-jump');
  }
  land(): void {
    // jump() stops the previous animation while retaining its animation key.
    // Replace the jump frame explicitly, then restart once (not every frame).
    if (!this.anims.isPlaying || this.anims.currentAnim?.key !== 'hero-run') {
      this.anims.stop();
      this.setTexture('hero-run-1');
      this.play('hero-run');
    }
  }
}
